import MainImg from "../images/chooseUs/main.png";
import Box1 from "../images/chooseUs/icon1.png";
import Box2 from "../images/chooseUs/icon2.jpg";
import Box3 from "../images/chooseUs/icon3.jpg";
import Box4 from "../images/chooseUs/icon4.jpg";

function ChooseUs() {
  return (
    <>
      <section className="choose-section" style={{marginTop:'-100px'}}>
        <div className="container">
          <div className="choose-container">
            <img
              className="choose-container__img"
              src={MainImg}
              alt="car_img"
            />
            <div className="text-container">
              <div className="text-container__left">
                <h4>Choosing Us Is Wise</h4>
                <h2>Best value to money deals to cater your trip</h2>
                <p>
                Experience a seamless car rental service in Freeport, Grand Bahama, offering exceptional deals on a diverse selection of reliable vehicles to suit all your travel needs. With a focus on affordability, we provide top-quality services and products designed to fit within your budget. Enjoy the freedom to explore the beauty of Freeport at your own pace with our customized rental options. Don't miss out on the opportunity to save on your next trip—our hassle-free, budget-friendly rentals are your ideal choice. Book your vehicle today and maximize your journey in Grand Bahama                </p>

             
              </div>
              <div className="text-container__right">
                {/*
                <div className="text-container__right__box">
                  <img src={Box1} alt="car-img" />
                  <div className="text-container__right__box__text">
                    <h4>All Vehicle Types</h4>
                    <p>
                     With all variety of vehicle types, take your driving experience to next level.
                    </p>
                  </div>
                </div>/
*/}

                
                <div className="text-container__right__box">
                  {" "}
                  <img src={Box2} alt="coin-img" />
                  <div className="text-container__right__box__text">
                    <h4>All Inclusive Pricing</h4>
                    <p>
                      Get everything you need in one convenient, transparent
                      price with our all-inclusive pricing policy.
                    </p>
                  </div>
                </div>


                <div className="text-container__right__box">
                  {" "}
                  <img src={Box4} alt="coin-img" />
                  <div className="text-container__right__box__text">
                    <h4>Road Side Assistance</h4>
                    <p>
                    We provide prompt roadside assistance to our customers in need.
                    </p>
                  </div>
                </div>




                <div className="text-container__right__box">
                  {" "}
                  <img src={Box3} alt="coin-img" />
                  <div className="text-container__right__box__text">
                    <h4>Quick Customer Support</h4>
                    <p>
                     We love our customers, get lightening support from our customer support.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ChooseUs;
